const loginRouter = {
  name: 'Login',
  path: '/login',
  component: () => import('@/views/Login.vue')
}

export default loginRouter
